import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { EmployeeNavbar } from "../reusedcomponent/navbar";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import DatePicker from "react-datepicker";
import { useHistory } from "react-router-dom";

export const CreateEmployee = () => {
  const alert = useAlert();
  const history = useHistory();
  const [roles, setRoles] = useState([]);
  const [jobtitles, setJobtitles] = useState([]);

  const getrole = async () => {
    const response = await ApiService.get("job-titles");
    const data = await ApiService.get("roles");
    console.log("res", response.data.jobtitle);
    setJobtitles(response.data.jobtitle);
    setRoles(data.data.roles);
  };

  let jobRoles = roles;
  delete jobRoles[3]
  
  useEffect(() => {
    getrole();
  }, []);

  return (
    <React.Fragment>
      <EmployeeNavbar />
      <div className="container">
        <div className="">
          <div className="registration-form  p-10-label col-md-12">
            <Formik
              initialValues={{
                first_name: "",
                middle_name: "",
                last_name: "",
                email: "",
                date_of_employment: "",
                role: "",
                job_title: "",
                gender: "",
              }}
              validate={(values) => {
                const errors = {};
                if (!values.email) {
                  errors.email = "Required";
                } else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = "Invalid email address";
                }
                return errors;
              }}
              // validationSchema={Yup.object({
              //   first_name: Yup.string().required(
              //     "First name should not be empty"
              //   ),
              //   last_name: Yup.string().required(
              //     "Last name should not be empty"
              //   ),
              //   email: Yup.string().required("email should not be empty"),
              //   date_of_employment: Yup.string().required(
              //     "Date of employment should not be empty"
              //   ),
              //   role: Yup.string().required("role should not be empty"),
              //   job_title: Yup.string().required(
              //     "Job jobtitle should not be empty"
              //   ),
              //   gender: Yup.string().required("gender should not be empty"),
              // })}
              onSubmit={async (values, { setSubmitting }) => {
               
                values.date_of_employment = new Date( values.date_of_employment.getTime() + Math.abs(values.date_of_employment.getTimezoneOffset()*60000));
                ApiService.post("users/create-employee", values).then((res) => {
                  if (res.data.type === false) {
                    setSubmitting(false);
                    alert.error(res.data.msg);
                  } else if (res.data.type === true) {
                    alert.success(res.data.msg);
                    history.push("/dashboard/employee");
                  }
                });
              }}
            >
              {({
                isSubmitting,
                values,
                setFieldValue,
                touched,
                errors,
                handleChange,
              }) => (
                <Form>
                  <div className="col-md-12">
                    <div className="form-icon">
                      <span>
                        <i className="icon icon-user"></i>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>
                            First Name <span className="text-danger"> * </span>
                          </label>
                          <Field
                            type="text"
                            id="first_name"
                            className="form-control item"
                            name="first_name"
                            placeholder="Enter first name"
                            onChange={handleChange}
                            value={values.first_name}
                            required
                          />
                          {touched.first_name && errors.first_name ? (
                            <div className="text-danger">
                              {errors.first_name}
                            </div>
                          ) : null}
                        </div>
                        <div className="form-group">
                          <label>
                            Last Name <span className="text-danger"> * </span>
                          </label>
                          <Field
                            type="text"
                            id="last_name"
                            className="form-control item"
                            name="last_name"
                            placeholder="Enter last name"
                            required
                          />
                          {touched.last_name && errors.last_name ? (
                            <div className="text-danger">
                              {errors.last_name}
                            </div>
                          ) : null}
                        </div>

                        <div className="form-group">
                          <label>Middle Name</label>
                          <Field
                            type="text"
                            id="middle_name"
                            className="form-control item"
                            name="middle_name"
                            placeholder="Enter middle name"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>
                            Gender <span className="text-danger"> * </span>
                          </label>
                          <select
                            type="text"
                            id="gender"
                            className="form-control"
                            name="gender"
                            onChange={handleChange}
                            value={values.gender}
                            required
                          >
                            <option value="">--Select Gender--</option>
                            <option value="male">MALE</option>
                            <option value="female">FEMALE</option>
                          </select>
                          {touched.gender && errors.gender ? (
                            <div className="text-danger">{errors.gender}</div>
                          ) : null}
                        </div>

                        <div className="form-group mt-4">
                          <label>
                            Employee Email{" "}
                            <span className="text-danger"> * </span>
                          </label>
                          <Field
                            type="text"
                            id="email"
                            className="form-control item"
                            name="email"
                            placeholder="Enter needle technology Email"
                            required
                          />
                          {touched.email && errors.email ? (
                            <div className="text-danger">{errors.email}</div>
                          ) : null}
                        </div>

                        <div className="form-group mt-4">
                          {/* <div className="input-group mb-3"> */}
                          <label>
                            Job Title <span className="text-danger"> * </span>
                          </label>
                          <select
                            type="text"
                            className="form-control"
                            id="job_title"
                            name="job_title"
                            onChange={handleChange}
                            value={values.job_title}
                            required
                          >
                            <option value="">--Select Job Title--</option>

                            {jobtitles &&
                              jobtitles.map((jobtitle, i) => (
                                <option value={jobtitle.id} key={i}>
                                  {jobtitle.name}
                                </option>
                              ))}
                          </select>
                          {touched.job_title && errors.job_title ? (
                            <div className="text-danger">
                              {errors.job_title}
                            </div>
                          ) : null}{" "}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <label>
                          Date Of Employment{" "}
                          <span className="text-danger"> * </span>
                        </label>

                        <div className="form-group">
                          <DatePicker
                            selected={values.date_of_employment}
                            maxDate={new Date()}
                            showDisabledMonthNavigation
                            dateFormat="MMMM d, yyyy"
                            className="form-control"
                            name="date_of_employment"
                            onChange={(date) =>
                              setFieldValue("date_of_employment", date)
                            }
                            required
                          />
                        </div>

                        <div className="form-group mt-4">
                          {/* <div className="input-group mb-3"> */}
                          <label>
                            Role <span className="text-danger"> * </span>
                          </label>
                          <select
                            type="text"
                            className="form-control"
                            name="role"
                            onChange={handleChange}
                            value={values.role}
                            required
                          >
                            <option value="">--Select Role--</option>

                            {jobRoles&&jobRoles.map((role, i) => (
                              <option value={role.id} key={i}>
                                {role.name}
                              </option>
                            ))}
                          </select>
                          {touched.role && errors.role ? (
                            <div className="text-danger">{errors.role}</div>
                          ) : null}{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button
                      type="submit"
                      className="btn btn-block nt-button-color-default btn-sm"
                    >
                      Save{" "}
                      {isSubmitting ? (
                        <span
                          id="login_spinner"
                          className="fa fa-spin fa-spinner"
                        ></span>
                      ) : null}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/employees/create_employee.js